import React, { memo } from 'react'
import { Styled } from './ModalDocumentValidation.styled'
import { ModalCloseIcon } from 'components/Icons/Icons'

const ModalDocumentValidation = memo(
  ({ onClose, onSelectAccountType, isValidating, hasMultipleAccountTypes, hasNegativeBalance }) => {
    const handleSelectAccountType = (accountType) => {
      onSelectAccountType(accountType)
      onClose()
    }

    return (
      <Styled.Wrap onClick={onClose}>
        <Styled.ModalContent onClick={(e) => e.stopPropagation()}>
          <Styled.Header hasTitle={hasMultipleAccountTypes}>
            {hasMultipleAccountTypes && (
              <Styled.Title>Escolha o tipo de conta</Styled.Title>
            )}
            <Styled.CloseButton onClick={onClose}>
              <ModalCloseIcon />
            </Styled.CloseButton>
          </Styled.Header>

          <Styled.Content>
            {isValidating ? (
              <Styled.LoadingContainer>
                <Styled.LoadingSpinner />
                <Styled.LoadingText>Carregando...</Styled.LoadingText>
              </Styled.LoadingContainer>
            ) : (
              <>
                <Styled.HighlightSection>
                  <Styled.StarIcon>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 36 36"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M28.3997 34.8C28.0997 34.8 27.8997 34.7 27.6997 34.6L17.9997 27.4L8.2997 34.4C7.8997 34.7 7.2997 34.7 6.8997 34.4C6.4997 34.1 6.2997 33.5 6.4997 33.1L10.1997 22.2L0.599702 15.6C0.199702 15.3 -0.000297852 14.8 0.0997021 14.3C0.299702 13.8 0.699702 13.5 1.1997 13.5H13.1997L16.8997 2.00001C16.9997 1.50001 17.4997 1.20001 17.9997 1.20001C18.4997 1.20001 18.9997 1.50001 19.0997 2.00001L22.7997 13.4H34.7997C35.2997 13.4 35.7997 13.7 35.8997 14.2C36.0997 14.7 35.8997 15.2 35.3997 15.5L25.7997 22L29.4997 33.1C29.6997 33.6 29.4997 34.1 29.0997 34.4C28.8997 34.7 28.5997 34.8 28.3997 34.8ZM17.9997 24.7C18.2997 24.7 18.4997 24.8 18.6997 24.9L25.9997 30.3L23.2997 22C23.0997 21.5 23.2997 20.9 23.7997 20.6L30.9997 15.7H21.9997C21.4997 15.7 20.9997 15.4 20.8997 14.9L17.9997 6.30001L15.1997 15C14.9997 15.5 14.5997 15.8 14.0997 15.8H5.0997L12.2997 20.7C12.6997 21 12.8997 21.6 12.7997 22.1L9.9997 30.3L17.2997 25C17.4997 24.8 17.7997 24.7 17.9997 24.7Z"
                        fill="#FFB800"
                      />
                    </svg>
                  </Styled.StarIcon>
                  <Styled.HighlightText>
                    Mais praticidade para você!
                  </Styled.HighlightText>
                </Styled.HighlightSection>

                {hasNegativeBalance ? (
                  <>
                    <Styled.Description>
                      Seus pontos PF e PJ agora funcionam juntos.<br />
                      Caso uma das contas esteja com saldo negativo, o resgate poderá ser feito apenas com os pontos da conta que estiver positiva, respeitando a origem do saldo (PF ou PJ)
                    </Styled.Description>
                  </>
                ) : (
                  <>
                    <Styled.Description>
                      Seus pontos PF e PJ agora funcionam juntos.<br />
                      Escolha uma conta e pronto: a soma dos pontos é feita automaticamente,
                      sem necessidade de transferência.
                    </Styled.Description>
                  </>
                )}

                <Styled.Subtitle>
                  Escolha como deseja iniciar seu resgate:
                </Styled.Subtitle>

                <Styled.ButtonContainer>
                  <Styled.ModalButton
                    onClick={() => handleSelectAccountType('Physics')}
                  >
                    Conta PF
                  </Styled.ModalButton>

                  <Styled.ModalButton
                    onClick={() => handleSelectAccountType('Legal')}
                  >
                    Conta PJ
                  </Styled.ModalButton>
                </Styled.ButtonContainer>
              </>
            )}
          </Styled.Content>
        </Styled.ModalContent>
      </Styled.Wrap>
    )
  }
)

ModalDocumentValidation.displayName = 'ModalDocumentValidation'

export default ModalDocumentValidation
